import React, { Component } from 'react';
import Firebase from 'firebase'

class Footer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataContact: []
    }
  }

  componentDidMount() {
    Firebase.database().ref('contact').on('value', data => {
      this.setState({dataContact: data.val()})
    })
  }

  render() { 
    let {dataContact} = this.state

    return (
      <footer className="ftco-footer ftco-section">
        <div className="container">
          <div className="row mb-5" style={{justifyContent: 'space-evenly'}}>
            <div className="col-md-4">
              <div className="ftco-footer-widget mb-4" style={{textAlign: 'center'}}>
                <h2 className="ftco-heading-2">About Samawa.</h2>
                <p>Kami adalah jasa pembuatan website dengan bekal pengalaman coding kami dalam membuat website yang modern.</p>
                <ul className="ftco-footer-social list-unstyled float-md-left float-lft mt-5" style={{width: '100%'}}>
                  {dataContact.twitter ? <li><a href={dataContact.twitter}><span className="icon-twitter"></span></a></li> : ''}
                  {dataContact.facebook ? <li><a href={dataContact.facebook}><span className="icon-facebook"></span></a></li> : ''}
                  {dataContact.instagram ? <li><a href={dataContact.instagram}><span className="icon-instagram"></span></a></li> : ''}
                </ul>
              </div>
            </div>
            <div className="col-md-4">
              <div className="ftco-footer-widget mb-4">
                <h2 className="ftco-heading-2">Have a Questions?</h2>
                <div className="block-23 mb-3">
                  <ul>
                    <li><span className="icon icon-map-marker"></span><span className="text">{dataContact.address}</span></li>
                    <li><a><span className="icon icon-phone"></span><span className="text">{dataContact.phone}</span></a></li>
                    <li><a><span className="icon icon-envelope"></span><span className="text">{dataContact.email}</span></a></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12 text-center">
              <p>
                Copyright &copy;2020 All rights reserved | <a href="#">Samawa</a>
              </p>
            </div>
          </div>
        </div>
      </footer>
    );
  }
}
 
export default Footer;